// Angular
import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-attachment-multiple',
    templateUrl: './attachment.multiple.component.html',
    styleUrls: ['./attachment.multiple.component.scss']
})

export class AttachmentMultipleComponent implements OnInit, OnChanges {

    @Input() cta: string;
    @Input() accept: string;
    @Input() reset: boolean;

    @Output() onChange: EventEmitter<any>;
    public attachments: Array<any> = [];
    public outputAttachments: Array<any> = []
    public imgSrc;
    public thumbnail: string;
    imageChangedEvent: any = '';

    constructor() {
        this.cta = 'Add photo or video';
        this.accept = 'image/*,video/*';
        this.onChange = new EventEmitter();
        if (this.reset) {
            this.attachments = []
            this.outputAttachments = []
        }
    }
    ngOnInit() {
        if (this.reset) {
            this.attachments = []
            this.outputAttachments = []

        }
    }

    ngOnChanges() {
        if (this.reset) {
            this.attachments = []
            this.outputAttachments = []

        }
    }
    fileChangeEvent(event: any): void {
        if (!event.target.files.length) {
            return;
        }

        for (var i = 0; i < event.target.files.length; i++) {
            const file = event.target.files.item(i);
            if (file.type.match('image.*')) {
                // console.log(file)
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    this.thumbnail = reader.result;

                    const image = new Image();
                    image.src = reader.result;

                    image.onload = () => {
                        this.attachments.push({
                            file: file,
                            width: image.width,
                            height: image.height,
                            type: 'image',
                            src: image.src,

                        })

                        this.outputAttachments.push({
                            file: file,
                            width: image.width,
                            height: image.height,
                            type: 'image',
                            src: image.src
                        })

                    };

                };
            } else if (file.type.match('video.*')) {

                this.attachments.push({
                    file: file,
                    type: 'video',
                })
            } else if (file.type.match('application/pdf')) {

                this.attachments.push({
                    file: file,
                    type: 'pdf',
                })
            } else {

                this.attachments.push({
                    file: file,
                    type: 'other',
                })
            }
        }
        // console.log(this.attachments)
        this.onChange.emit({ original: this.attachments, cropped: this.outputAttachments });
    }

    public remove(i): void {
        this.attachments.splice(i, 1)
        this.outputAttachments.splice(i, 1)


        this.onChange.emit({ original: this.attachments, cropped: this.outputAttachments });

    }
    imageCropped(image: string, index) {
        // console.log(image)
        var file = this.dataURLtoFile(image)
        if (file.type.match('image')) {

            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = () => {

                const image = new Image();
                image.src = reader.result;
                image.onload = () => {
                    console.log(index, image.width, image.height);

                    this.outputAttachments[index] = {
                        file: file,
                        width: image.width,
                        height: image.height,
                        type: 'image',
                        src: image.src

                    };
                    this.onChange.emit({ original: this.attachments, cropped: this.outputAttachments });

                };
            };
        }

    }
    imageLoaded() {
        // show cropper
    }
    loadImageFailed() {
        // show message
    }
    dataURLtoFile(dataurl) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], this.randomString(5), { type: mime });
    }
    randomString(length) {
        var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
        var result = '';
        for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    }
}
